(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["birthday"] && !Shopify.designMode) return;
  try {
    
// Automator sentence: drives the blanks from scroll position, with a
// confetti burst when the last blank lands.
// Degrades to a static, fully-filled sentence if JS or motion is unavailable.
(function () {
  var LEAD_IN = 0.12; // portion of the scroll before the first blank fills

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* ---------- confetti ---------- */
  function makeConfetti(section, canvas) {
    var ctx = canvas.getContext('2d');
    var parts = [];
    var raf = null;
    var dpr = 1;

    function palette() {
      var cs = getComputedStyle(section);
      function t(name, fallback) {
        var v = cs.getPropertyValue(name).trim();
        return v || fallback;
      }
      var accent = t('--color-accent', '#dd2476');
      var p200 = t('--color-brand-pink-200', '#fccee8');
      var p400 = t('--color-brand-pink-400', '#f670b6');
      var p800 = t('--color-brand-pink-800', '#9f154d');
      var lime = t('--color-brand-lime-400', '#a8e825');
      var ink = t('--color-foreground', '#0a0a0a');
      // weighted across the pink ramp, with the lime secondary accent and a
      // little ink for contrast
      return [accent, accent, accent, p400, p400, p200, p200, lime, lime, p800, ink];
    }

    function resize() {
      var r = canvas.getBoundingClientRect();
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.max(1, r.width * dpr);
      canvas.height = Math.max(1, r.height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function tick() {
      var r = canvas.getBoundingClientRect();
      ctx.clearRect(0, 0, r.width, r.height);

      for (var i = parts.length - 1; i >= 0; i--) {
        var p = parts[i];
        p.life++;
        p.vy += 0.28;   // gravity
        p.vx *= 0.992;  // drag
        p.vy *= 0.992;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;

        if (p.life > p.ttl || p.y > r.height + 40) {
          parts.splice(i, 1);
          continue;
        }

        var fade = p.life > p.ttl * 0.6
          ? Math.max(0, 1 - (p.life - p.ttl * 0.6) / (p.ttl * 0.4))
          : 1;

        ctx.save();
        ctx.globalAlpha = fade;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.col;
        if (p.round) {
          ctx.beginPath();
          ctx.arc(0, 0, p.w / 2, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        }
        ctx.restore();
      }

      if (parts.length) {
        raf = window.requestAnimationFrame(tick);
      } else {
        raf = null;
        ctx.clearRect(0, 0, r.width, r.height); // idle: no rAF running
      }
    }

    function burst(ox, oy, amount) {
      resize();
      var cols = palette();
      var n = amount || 110;
      for (var i = 0; i < n; i++) {
        var a = (-Math.PI / 2) + (Math.random() - 0.5) * 2.0;
        var sp = 4 + Math.random() * 10;
        parts.push({
          x: ox + (Math.random() - 0.5) * 50,
          y: oy + (Math.random() - 0.5) * 14,
          vx: Math.cos(a) * sp * (0.85 + Math.random() * 0.6),
          vy: Math.sin(a) * sp,
          w: 4 + Math.random() * 6,
          h: 6 + Math.random() * 8,
          rot: Math.random() * Math.PI * 2,
          vr: (Math.random() - 0.5) * 0.34,
          col: cols[(Math.random() * cols.length) | 0],
          round: Math.random() < 0.22,
          life: 0,
          ttl: 100 + Math.random() * 70
        });
      }
      if (!raf) raf = window.requestAnimationFrame(tick);
    }

    return { burst: burst, resize: resize };
  }

  function setup(section) {
    if (!section || section.__automatorSentence) return;

    var scroller = section.querySelector('.automator-sentence__scroller');
    var sticky = section.querySelector('.automator-sentence__sticky');
    if (!scroller || !sticky) return;

    var clauses = Array.prototype.slice.call(section.querySelectorAll('.automator-sentence__clause'));
    var slots = Array.prototype.slice.call(section.querySelectorAll('.automator-sentence__slot'));
    var captions = Array.prototype.slice.call(section.querySelectorAll('.automator-sentence__caption'));
    var counter = section.querySelector('[data-current-step]');
    var result = section.querySelector('[data-result]');
    var canvas = section.querySelector('[data-confetti]');
    if (!slots.length) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return; // CSS already handles the static fallback

    var count = slots.length;
    var current = null;
    var ticking = false;
    var celebrated = false;

    // Split each filled phrase into words so they can stagger in
    slots.forEach(function (slot) {
      var fl = slot.querySelector('.automator-sentence__filled');
      if (!fl || fl.querySelector('.automator-sentence__word')) return;
      var words = fl.textContent.trim().split(/\s+/);
      fl.textContent = '';
      words.forEach(function (w, i) {
        var s = document.createElement('span');
        s.className = 'automator-sentence__word';
        s.style.setProperty('--i', i);
        s.textContent = w;
        fl.appendChild(s);
        if (i < words.length - 1) fl.appendChild(document.createTextNode(' '));
      });
    });

    var confetti = canvas ? makeConfetti(section, canvas) : null;

    function fireConfetti() {
      if (!confetti) return;
      var last = slots[slots.length - 1];
      var sr = sticky.getBoundingClientRect();
      var lr = last.getBoundingClientRect();
      confetti.burst(lr.left - sr.left + lr.width / 2, lr.top - sr.top + lr.height / 2);
    }

    // Measure each blank's empty and filled widths so the pill grows into
    // place rather than sitting at full width with the short text adrift.
    function sizeSlots() {
      slots.forEach(function (slot) {
        var ph = slot.querySelector('.automator-sentence__placeholder');
        var fl = slot.querySelector('.automator-sentence__filled');
        if (!ph || !fl) return;
        var cs = getComputedStyle(slot);
        var padX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
        slot.dataset.wEmpty = (ph.offsetWidth + padX) + 'px';
        slot.dataset.wFull = (fl.offsetWidth + padX) + 'px';
        var filled = slot.classList.contains('is-filled');
        slot.style.setProperty('--slot-w', filled ? slot.dataset.wFull : slot.dataset.wEmpty);
      });
    }

    function apply(step, progress) {
      scroller.style.setProperty('--progress', progress.toFixed(4));

      if (step === current) return;
      current = step;

      var active = Math.max(step, 0);

      clauses.forEach(function (clause, i) {
        clause.classList.toggle('is-reached', i <= step);
      });

      slots.forEach(function (slot, i) {
        var on = i <= step;
        slot.classList.toggle('is-filled', on);
        slot.classList.toggle('is-past', i < step);
        if (slot.dataset.wFull) {
          slot.style.setProperty('--slot-w', on ? slot.dataset.wFull : slot.dataset.wEmpty);
        }
      });

      captions.forEach(function (cap, i) {
        cap.classList.toggle('is-active', i === active);
      });

      if (counter) counter.textContent = pad(active + 1);

      var done = step >= count - 1;
      if (result) result.classList.toggle('is-visible', done);

      if (done && !celebrated) {
        celebrated = true;
        setTimeout(fireConfetti, 420); // lands as the final word settles
      } else if (!done) {
        celebrated = false;            // re-arm on the way back up
      }
    }

    function measure() {
      var rect = scroller.getBoundingClientRect();
      var travel = rect.height - sticky.offsetHeight;
      if (travel <= 0) {
        apply(count - 1, 1);
        return;
      }

      // The sticky pins below the header, so its rect.top rests at that offset
      // rather than 0 — without subtracting it the last step never reaches 1.
      var pinTop = parseFloat(window.getComputedStyle(sticky).top) || 0;
      var progress = Math.min(Math.max((pinTop - rect.top) / travel, 0), 1);

      var step = -1;
      if (progress >= LEAD_IN) {
        var band = (1 - LEAD_IN) / count;
        step = Math.min(Math.floor((progress - LEAD_IN) / band), count - 1);
      }

      apply(step, Math.min(Math.max((progress - LEAD_IN) / (1 - LEAD_IN), 0), 1));
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        measure();
        ticking = false;
      });
    }

    function boot() {
      scroller.setAttribute('data-ready', '');
      sizeSlots();
      current = null;
      measure();
    }

    // Widths depend on the webfont, so wait for it before measuring
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(boot);
    } else {
      boot();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      sizeSlots();
      if (confetti) confetti.resize();
      current = null;
      measure();
    });

    // Theme editor: selecting a blank jumps straight to it
    section.__automatorSentenceJump = function (index) {
      apply(index, (index + 1) / count);
    };

    section.__automatorSentence = true;
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var sections = Array.prototype.slice.call(root.querySelectorAll('[data-automator-sentence]'));
    if (root !== document && root.matches && root.matches('[data-automator-sentence]')) {
      sections.push(root);
    }
    sections.forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  document.addEventListener('shopify:block:select', function (e) {
    var clause = e.target.closest('.automator-sentence__clause');
    var section = e.target.closest('[data-automator-sentence]');
    if (clause && section && section.__automatorSentenceJump) {
      section.__automatorSentenceJump(parseInt(clause.getAttribute('data-clause'), 10));
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
